const ModalHolder = ({ children }) => {
    return (
      <div
        style={{
          position: "absolute",
          zIndex: 100,
          width: "100%",
          height: "100%",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            padding: "20px",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {children}
        </div>
      </div>
    );
  };

  export default ModalHolder
  